import { useEffect, useState } from "react";
import { api } from "../../../../service/api";
import { useSearchParams } from "react-router-dom";

interface IFormatDataChart {
  no_reply: number;
  success: number;
  error: number;
  total_questions: number;
  percentage: number;
}

export function useSimulatorVolume() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<boolean | null>(null);
  const [dataList, setDataList] = useState<IFormatDataChart>(
    {} as IFormatDataChart
  );

  const [searchParams] = useSearchParams();

  const start_date = searchParams.get("start_date") ?? "";
  const end_date = searchParams.get("end_date") ?? "";

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await api.get(
        `dash/simulator/list?start_date=${start_date}&end_date=${end_date}`
      );
      const dataValue = response.data;
      setDataList(dataValue);
    } catch (error) {
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [start_date, end_date]);

  return {
    dataList,
    loading,
    error,
    refetch: fetchData,
  };
}
